define(function (require) {

    var agentLEManager = require('web-agent-utils/agentLEManager');

    /**
     * key for 'now' item
     * @const
     * @type {string}
     */
    var NOW_KEY = 'Now';

    /**
     * translate web agent keys - key will be prefixed with LEWebAgent before send to translation
     * key {String} translation key
     * @private
     * @returns {String}
     */
    function _translate(key) {
        return agentLEManager.translateLE('LEWebAgent.' + key);
    }


    /**
     * Get the operation hours options. for the FormDropdownViewController
     * keys: 00:00:00, 00:30:00, 01:00:00, 01:30:00, 02:00:00, 02:30:00 ... 23:30:00
     * values: 12:00 am, 12:30 am, 1 am, 1:30 am,  2 am, 2:30 am ... 11:30 pm
     * hour: 12, 12, 1, 1, 2, 2 ... 11
     * minute: 0, 30, 0 , 30, 0, 30 .. 30
     *
     * @param {Boolean=} addNow add 'now' option item
     * @returns array
     */
    function getHoursItems(addNow) {
        var items = [];
        if (addNow) {
            items.push({key: NOW_KEY, value: _translate("filter_timeFrame_now"), hour: -1, minute: -1});
        }
        for (var number=0; number<24; number++){
            var key = (number > 9) ? number.toString() : "0" + number.toString();
            var key2 = key + ":30:00";
            key = key + ":00:00";
            var ampmString = number < 12 ? agentLEManager.translateLE("LEReporting.AM").toLowerCase() : agentLEManager.translateLE("LEReporting.PM").toLowerCase();
            var value;
            var value2;
            if (number === 0) {
                value = "12:00 " + ampmString;
                value2 = "12:30 " + ampmString;
            }
            else if (number <= 12) {
                value = number + ":00 " + ampmString;
                value2 = number + ":30 " + ampmString;
            }
            else {
                value = (number - 12) + ":00 " +ampmString;
                value2 = (number - 12) + ":30 " +ampmString;
            }
            items.push({key:key, value:value, hour :number, minute: 0 });
            items.push({key:key2, value:value2, hour :number, minute: 30});
        }

        return items;
    }

    /**
     * Return the time index of the date for the FormDropdownViewController
     * @param {Date|String} date
     * @param {boolean=} considerNow - if true, we consider that there's a "Now" time at index 0.
     * @returns {number}
     */
    function getIndexOfTime(date, considerNow){
        if (date === NOW_KEY || !date) {
            return 0;
        }
        var hour = date.getHours();
        var index = hour *2;
        if (date.getMinutes() >= 30) {
            index++;
        }
        // send the next index
        if (considerNow) {
            index++;
        }
        return index;
    }


    /**
     * Creates Date object from long number
     * @param {Number|Date} dateInLong
     * @returns {Date}
     */
    function createDateFromLong(dateInLong) {
        var retVal = new Date(dateInLong);
        // Set the seconds to 0 and the minutes to 00 or 30
        retVal.setSeconds(0);
        retVal.setMilliseconds(0);
        if  (retVal.getMinutes() > 0){
            retVal.setMinutes(30);
        } else if (retVal.getMinutes() > 30) {
            retVal.setMinutes(0);
            retVal.setHours( retVal.getHours() +1);
        }
        return retVal;
    }

    /**
     * Returns the number of days of the last x months
     * @param {Number} numOfMonths number of the last months to calculate
     * @returns {Number}
     * @private
     */
    function getLastMonthsDurationInDays(numOfMonths){
        var nowTime = Date.now();
        var start = new Date();
        start.setMonth(start.getMonth() - numOfMonths);

        return Math.floor((nowTime - start.getTime()) / (1000 * 60 * 60 * 24));   //conversion of ms to full days
    }


    return {
        NOW_KEY: NOW_KEY,
        getHoursItems: getHoursItems,
        getIndexOfTime: getIndexOfTime,
        createDateFromLong: createDateFromLong,
        getLastMonthsDurationInDays: getLastMonthsDurationInDays
    };

});
